import { render, staticRenderFns } from "./Exchange.vue?vue&type=template&id=d19c29e6&scoped=true"
import script from "./Exchange.vue?vue&type=script&lang=ts&setup=true"
export * from "./Exchange.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Exchange.vue?vue&type=style&index=0&id=d19c29e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack@5.111.1__ejs@3.1._d122e8da27108b932c0dfa09e6e9a5ee/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19c29e6",
  null
  
)

export default component.exports